export default __webpack_public_path__ + "static/gmc-in-email-4bee1ef8089583599e2e57c16cd5cbcc.png";